import { guidFor } from "@ember/object/internals";
import Component from "@glimmer/component";

export interface S {
  Element: HTMLDivElement;
  Args: {
    onChange: (value: string) => void;
    label: string;
    dataTest: string;
    min: string;
    max: string;
    step: string;
    value: string;
  };
  Blocks: { values: [] };
}

export default class Progress extends Component<S> {
  declare progress: number;

  onChange = (event: InputEvent): void => {
    this.args.onChange((event.target as HTMLInputElement).value);
  };

  get inputId(): string {
    return guidFor(this);
  }
}
